export default "/assets/website/images/st6.jpg?5ff5c13d0ee0bd9cc93f313fb29d24a7";